import { DESIGN_LAB_PREVIEW_BASED_EXTENSIONS } from "common/artwork-file-types";

export function getFileUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async event => {
      resolve(String(event.target?.result));
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function downloadFile(url: string, filename: string): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(blobUrl);
}

export function isPreviewBasedFile(file: File): boolean {
  return Boolean(file.type.match(DESIGN_LAB_PREVIEW_BASED_EXTENSIONS));
}

export function toFileObject(file: File, fallbackUrl?: string) {
  if (isPreviewBasedFile(file)) {
    return { url: URL.createObjectURL(file), file };
  }
  return { url: fallbackUrl, file };
}
